/* @flow strict */

import _ from 'lodash';
import * as React from 'react';
import { emailRegexp } from '/client/src/constants/';

type PropsType = {
    handleSetReferrals: () => void
};

const ReferralCreate = ({ handleSetReferrals }: PropsType): React.Element<'div'> => {
    const initReferral = {
        id: Math.random(),
        email: '',
        name: '',
        isEmailValid: true,
        isNameValid: true
    };

    const [referrals, setReferrals] = React.useState([initReferral]);

    React.useEffect(() => {
        handleSetReferrals(referrals);

        if (referrals.every((ref: any): any => ref.name && ref.email && ref.isEmailValid)) {
            addReferral(); // init another one referral form if all others are already filled
        }
    }, [referrals]);

    const addReferral = () => {
        setReferrals((_refs: any): any => [..._refs, initReferral]);
    };

    const updateReferral = (id: number, email?: string, name?: string) => {
        if (!email && !name) {
            removeReferral(id);
        }
        setReferrals((_refs: any): any =>
            _refs.map((_ref: any): any => {
                if (_ref.id === id) {
                    return {
                        ..._ref,
                        email,
                        name,
                        isEmailValid: _.size(email) ? emailRegexp.test(email) : false,
                        isNameValid: !!_.size(name)
                    };
                }
                return _ref;
            }),
        );
    };

    const removeReferral = (id: number) => {
        setReferrals((_refs: any): any =>
            _refs.filter((_ref: any): any => _ref.id !== id),
        );
    };

    return (
        <div className='referral-form'>
            {referrals.map((el: any, i: number): React.Element<'div'> => (
                <div className="form-group" key={i}>
                    <div className="input-group">
                        <label htmlFor="email">Referral Email</label>
                        <input
                          type="email"
                          className={`form-control ${!el.isEmailValid ? 'form-control_error' : ''}`}
                          value={el.email}
                          onChange={(e): void => updateReferral(el.id, e.target.value, el.name)}
                        />
                        {
                            !el.isEmailValid && <span className="validationMessage">Please enter correct email</span>
                        }
                    </div>
                    <div className="input-group">
                        <label htmlFor="email">Refferal Name</label>
                        <input
                          type="text"
                          className={`form-control ${!el.isNameValid ? 'form-control_error' : ''}`}
                          value={el.name}
                          onChange={(e): void => updateReferral(el.id, el.email, e.target.value)}
                        />
                        {
                            !el.isNameValid && <span className="validationMessage">Please enter name</span>
                        }
                    </div>
                </div>
            ))
            }
        </div>
    );
};

export default ReferralCreate;
